// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../node_modules/postcss-loader/src/index.js!../styleGuide.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".src-components-App__smallScreenWrap--2v7i6{position:absolute;top:0;width:100%;height:100%;background-color:rgba(0,0,0,.3);z-index:100;display:flex;justify-content:center;align-items:center}.src-components-App__buttonWrap--1KLPi{float:right}.src-components-App__button--mqW_U{margin-top:20rem;height:58rem;line-height:58rem}.src-components-App__dialogContent--2Pobw{position:relative;background-color:#fff;padding:32rem;font-size:32rem;width:500rem}.src-components-App__dialogContent--2Pobw h2{font-size:48rem}", ""]);
// Exports
exports.locals = {
	"buttonPrimary": "" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["buttonPrimary"] + "",
	"smallScreenWrap": "src-components-App__smallScreenWrap--2v7i6",
	"buttonWrap": "src-components-App__buttonWrap--1KLPi",
	"button": "src-components-App__button--mqW_U " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["buttonPrimary"] + "",
	"dialogContent": "src-components-App__dialogContent--2Pobw"
};
module.exports = exports;
